import React from "react";
import { AccordionSummary, Box, Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "./styles";

type Props = {
  heading: string;
};

export default function Heading({ heading = "--" }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel5bh-content"
        id="panel5bh-header"
      >
        <Grid container direction="row">
          <Grid item xs={12} md={11}>
            <Box color="text.secondary">
              <Typography className={classes.heading}>{heading}</Typography>
            </Box>
          </Grid>
        </Grid>
      </AccordionSummary>
    </>
  );
}
